import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseHistoryModel from "../../models/case-history";

export default class CaseHistoryRepository extends BaseRepository {
  static modelClass = CaseHistoryModel;
  modelName = "case-history";

  async query({ caseId }) {
    return await super.query({
      urlPath: `case/${caseId}/history`,
    });
  }
}
